import { useCallback } from 'react';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useLocalStorageState } from 'ahooks';
import { klona } from 'klona';

interface DisclaimerParams {
  isFirstLaunch: boolean;
  lastPopupDate: string;
}

// 扩展 dayjs 的 ISO 周支持
dayjs.extend(isoWeek);

const useWeeklyPopup = () => {
  // 使用 localStorage 存储首次安装状态

  const [disclaimerParams, setDisclaimerParams] = useLocalStorageState<DisclaimerParams>('disclaimer-params', {
    defaultValue: {
      isFirstLaunch: true,
      lastPopupDate: null,
    },
    listenStorageChange: true,
  });

  // 检查是否应该显示弹窗
  const shouldShowPopup = (): boolean => {
    // 如果当前环境不是生产环境，不显示弹窗
    if (['dev', 'undefined']?.includes(__BUILD_ENV__)) return false;
    const now = dayjs();
    // 1. 如果是首次安装，总是显示
    if (disclaimerParams?.isFirstLaunch) return true;

    // 2. 如果没有最后弹窗日期，显示弹窗
    if (!disclaimerParams?.lastPopupDate) return true;

    // 3. 检查是否在同一周
    const lastPopupDay = dayjs(disclaimerParams?.lastPopupDate);
    return !now.isSame(lastPopupDay, 'isoWeek');
  };

  // 标记弹窗已显示
  const markAsShown = useCallback((): void => {
    const now = dayjs().toISOString();
    if (disclaimerParams?.isFirstLaunch) {
      setDisclaimerParams(preVal => {
        const newVal = klona(preVal);
        newVal.isFirstLaunch = false;
        newVal.lastPopupDate = now;
        return newVal;
      });
    } else {
      setDisclaimerParams(preVal => {
        const now = dayjs().toISOString();
        const newVal = klona(preVal);
        newVal.lastPopupDate = now;
        return newVal;
      });
    }
  }, [disclaimerParams?.isFirstLaunch, setDisclaimerParams]);

  return { shouldShowPopup, markAsShown };
};

export default useWeeklyPopup;
